import { useQuery } from "@tanstack/vue-query";
import CallDisposition from "@/services/call-disposition";

export interface CallDispositionsParams {
  organizationId?: string;
}

export function useCallDispositions(params?: any) {
  return useQuery({
    queryKey: ["callDispositions"],
    queryFn: async () => {
      const result = await CallDisposition.getCallDispositions({});

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to load call dispositions");
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
